<template>
<!--    <div class="flex justify-center items-center py-5">-->
<!--        <div @click="$emit('pagechange', 1)" class="cursor-pointer"><i class="fas fa-angle-double-left text-xl px-2 hover:text-gray-400"></i>-->
<!--        </div>-->
<!--        <div @click="$emit('pagechange', Math.max(current-1,1))" class="cursor-pointer"><i-->
<!--            class="fas fa-angle-left text-xl px-2 hover:text-gray-400"></i></div>-->
<!--        <div @click="$emit('pagechange', i)" v-for="i in last" :key="i"-->
<!--             class="font-bold text-lg mx-1 px-2 border-2 border-next-neu hover:bg-next-neu hover:text-white cursor-pointer"-->
<!--             :class="{'bg-next-neu text-white': i === current}">-->
<!--            {{ i }}-->
<!--        </div>-->
<!--        <div @click="$emit('pagechange', Math.min(current+1, last))" class="cursor-pointer"><i-->
<!--            class="fas fa-angle-right text-xl px-2 hover:text-gray-400"></i></div>-->
<!--        <div @click="$emit('pagechange', last)" class="cursor-pointer"><i-->
<!--            class="fas fa-angle-double-right text-xl px-2 hover:text-gray-400"></i></div>-->
<!--    </div>-->
    <div class="">
        <div class="flex text-sm">
            <span class="mr-1">Righe totali: <span class="font-bold">{{pagination.total}}</span></span>
            <span class="mr-1">Righe per pagina: <span class="font-bold">{{pagination.per_page}}</span></span>
            <span class="mr-1">Pagine: <span class="font-bold">{{pagination.current_page}}</span> di <span class="font-bold">{{pagination.last_page}}</span></span>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'Paginator',
    props: {
        pagination: Object
    }
})
export default class Paginator extends Vue {
    pagination!: any
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
